import config from "appConfig";
import { LayoutComponent } from "@jelly/lesson";

const component: LayoutComponent = {
  variant: "layout",
  data: {
    type: "table",
    options: {
      cols: 2,
      rows: 1,
      colsSize: [1, 3],
      gap: "30px",
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              styles: {
                // alignItems: "flex-start",
              },
              block: {
                type: "text",
                options: {
                  data:
                    "Auralization and vehicle sound simulation can be usefull in many different NVH realted tasks and applications including virtual prototyping, active sound design (ASD), engine sound enhancement (ESE), and benchmarking. Furthermore, ....  \n" +
                    "\n" +
                    "<br />" +
                    "<br />" +
                    "Active Sound Design describes the process of adding artificial sounds to a product to improve the user experience. A virtual driving simulation  can be very useful during the sound design process. Often the sound design process starts during development phases where no physical prototypes are available yet. By using a simulator sounds can be designed based on real or estimated driving sounds and can be evaluated in representative driven situations.This greatly reduces the required time spend working on actual prototypes and increases the quality of the final sound design.",
                  styles: {
                    fontSize: "12px",
                    fontWeight: "600",
                  },
                  scrollbars: false,
                },
              },
            },
          },
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/03/case-02/principle/8-asd.png`,
                  viewType: "contain",
                  styles: {
                    maxWidth: "663px",
                  },
                },
              },
            },
          },
        ],
      ],
    },
  },
};

export default component;
